import React, { useState } from "react";
import { CheckedStates } from "../../Checkbox";
import { TableContext } from "../../hooks/useTableContext";
import { useThemeContext } from "../../theming/useThemeContext";
import { useGridColumnsClasses } from "../../utils/gridColumns";
import { getTableStyles } from "./tableStyles";
import { getTableHasCheckboxSelection, getTableHasDropdown, tableHasAction, } from "./utilsV2Table";
export function TableProvider(props) {
    var _a, _b;
    var _c = useThemeContext(), brandedTable = _c.brandedTable, client = _c.client;
    var drawer = props.drawer, headings = props.headings, form = props.form;
    var _d = useState(false), isBulk = _d[0], setIsBulk = _d[1];
    var tableHasActions = tableHasAction(props);
    var tableHasDropdown = getTableHasDropdown(props);
    var tableHasCheckboxSelection = getTableHasCheckboxSelection(props);
    var hasActionAtEnd = tableHasActions || tableHasDropdown;
    var hasActionAtStart = tableHasCheckboxSelection;
    var gridColumnsClasses = useGridColumnsClasses({
        headings: headings,
        drawer: !!drawer,
        hasActionAtStart: hasActionAtStart,
        hasActionAtEnd: hasActionAtEnd,
    });
    var _e = useState(), width = _e[0], setWidth = _e[1];
    var setTableWidth = function (newWidth) { return setWidth(newWidth); };
    var onSelectAll = function (previousState) {
        (form === null || form === void 0 ? void 0 : form.onSelectAll) && (form === null || form === void 0 ? void 0 : form.onSelectAll(previousState));
        if (form === null || form === void 0 ? void 0 : form.bulkMode) {
            previousState !== CheckedStates.Checked
                ? setIsBulk(true)
                : setIsBulk(false);
        }
    };
    return (React.createElement(TableContext.Provider, { value: {
            setTableWidth: setTableWidth,
            tableWidth: width,
            hasAction: hasActionAtEnd,
            gridClassName: (_a = gridColumnsClasses === null || gridColumnsClasses === void 0 ? void 0 : gridColumnsClasses.gridColumns) !== null && _a !== void 0 ? _a : "",
            onSelectAll: onSelectAll,
            isBulk: isBulk,
            tableTheme: getTableStyles((_b = props.theme) !== null && _b !== void 0 ? _b : brandedTable, props === null || props === void 0 ? void 0 : props.styling, props === null || props === void 0 ? void 0 : props.childTable, client),
        } }, props === null || props === void 0 ? void 0 : props.children));
}
